import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiPaginateResult } from '../apiservices/apipaginated';
import { APIService } from '../apiservices/apiservices';

export interface IArquivoLeitura {
  idArquivo?: string;
  idLogin?: string;
  loginUsuario?: string;
  nomeUsuario?: string;
  idEmpresa?: string;
  numContrato?: string;
}

@Injectable()

export class PrestacaoProvider {
  private header = APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {
  }

  criarArquivo(dto: any, isEdit = false): Promise<any> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'prestacaocontas?isEdit=' + isEdit;
      me.http.post(url, dto, {headers: this.header}).subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  get(empresa: string, contrato: string, mesCadastro: string, mesVigencia: string, statusLeitura: string, continuationToken: string) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'prestacaocontas';

      var params = [];
      if (empresa) {
        params.push(`empresa=${empresa}`)
      }

      if (contrato) {
        params.push(`contrato=${contrato}`)
      }

      if (mesCadastro) {
        params.push(`mesCadastro=${mesCadastro}`)
      }

      if (mesVigencia) {
        params.push(`mesVigencia=${mesVigencia}`)
      }

      if (statusLeitura) {
        params.push(`statusLeitura=${statusLeitura}`)
      }

      if (continuationToken) {
        params.push(`continuationToken=${continuationToken}`)
      }

      if (params.length) {
        url += `?${ params.join("&") }`;
      }

      me.http.get(url, {headers: this.header}).subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }
  
  getFilesByIds(ids: string[] | number[], empresa, contrato): Promise<any> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url =
        APIService.API_URL +
        'prestacaocontas?operacao=arquivos&ids=' +
        ids.join(',');

        var params = [];
        if (empresa) {
          params.push(`empresa=${empresa}`)
        }

        if (contrato) {
          params.push(`contrato=${contrato}`)
        }

        if (params.length) {
          url += `?${ params.join("&") }`;
        }

      me.http.get(url, { headers: this.header }).subscribe(
        (result: ApiPaginateResult) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
  
  /**
   * TODO
   */
  async postLeituraArquivo(body: IArquivoLeitura): Promise<any> 
  {
    var me = this;

    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'prestacaocontas?operacao=lido';

      me.http.post(url, body, {headers: this.header}).subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });

    });
  }

  deleteFile(id: string, empresa: string): Promise<any> {
    var me=this;
    this.header=APIService.getHeader();
    

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'prestacaocontas';

      me.http.delete(url, {headers: this.header, params: {
        id: id,
        empresa: empresa
      }}).subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });

    });
  }

  postLogVisualizacaoArquivos(dto: any): Promise<any> {
    var me = this;
    this.header = APIService.getHeader();
  
    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'prestacaocontas?operacao=logleitura';
      
      me.http.post(url, dto, { headers: this.header }).subscribe((result: any) => {
        resolve(result);
      }, (error) => {
        reject(error);
      });
    });
  }
  
  getLogVisualizacaoArquivos(IdProvision) {
    var me = this;
    this.header = APIService.getHeader();
  
    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + `prestacaocontas?operacao=logleitura&idProvision=${IdProvision}`;
  
      me.http.get(url, {headers: this.header}).subscribe((result: any) => {
        resolve(result);
      }, (error) => {
        reject(error);
      });
    });
  }
}
